/* eslint-disable @nx/enforce-module-boundaries */
import { container } from '@intigral/domain/lib/DataDomain';
import { __ } from '../../translations';
import { toast } from '@intigral/shared';
import { IEntitlementService } from '@intigral/domain/lib/application/services/EntitlementService';
import { DI } from '@intigral/constant/config/DIContainer';
import { CACHE_CONFIG_TYPES } from '@intigral/constant';
import { get } from '@intigral/utils/lib/browser-storage/localStorage';
import user from '../../helpers/user';
import h from '../../helpers/common';

export const setQitafProperty = (key, value) => {
    const qitaf = h.getStore('qitaf');
    return h.setStore('qitaf', { ...qitaf, [key]: value });
    // return h.setStore(key, value);
};
export const getQitafProperty = (key) => {
    const qitaf = h.getStore('qitaf');
    return qitaf?.[key];
    // return h.getStore(key);
};
export const resetQitafProperty = (key) => {
    const qitaf = h.getStore('qitaf');
    if (qitaf && key in qitaf) {
        delete qitaf[key];
        return h.setStore('qitaf', { ...qitaf });
    }
};

// This function is used to generate OTP for given productId and qitafMsisdn. It calls the API with established parameters and returns the response.
export const qitafGenerateOTPApi = ({ productId, qitafMsisdn, uid }) => {
    if (!productId || !qitafMsisdn) {
        return new Error('Invalid input');
    }
    const entitlementService = container.resolve<IEntitlementService>(DI.SERVICES.IEntitlementService);
    return entitlementService
        .qitafTvodGenerateOtp(
            productId,
            qitafMsisdn,
            uid,
            user.getAPIKey(),
            user.getUserToken(),
            user.getIdentityToken()
        )
        .then((response) => {
            if (response) {
                return response;
            } else {
                return [];
            }
        })
        .catch((err) => {
            toast(__(`err_msg_${err?.data?.code}`), 'error');
        });
};

// This function is used to verify OTP and it takes productId, qitafMsisdn, qitafRefId, otp and amount. It calls api with identity token and returns response.
export const qitafVerifyOTPApi = ({ productId, qitafMsisdn, qitafRefId, otp, amount, uid }, configParam?: any) => {
    if (!productId || !qitafMsisdn || !qitafRefId || !otp || !amount) {
        return new Error('Invalid input');
    }
    // Use provided config or fallback to localStorage for backward compatibility
    const config = configParam;

    const qitafMsisdnWithCode = config?.qitaf?.QitafMSISDNCountryCode + qitafMsisdn;
    const entitlementService = container.resolve<IEntitlementService>(DI.SERVICES.IEntitlementService);
    return entitlementService
        .qitafTvodVerifyOtp(
            productId,
            qitafMsisdnWithCode,
            qitafRefId,
            otp,
            amount,
            uid,
            user.getAPIKey(),
            user.getUserToken(),
            user.getIdentityToken()
        )
        .then((response) => {
            return response || [];
        })
        .catch((err) => {
            toast(__(`err_msg_${err?.data?.code}`), 'error');
        });
};
